export function getUrlParameters() {
	const query = location.href.split("?")[1] || "";
	const urlParameters = {};
	query.split("&").forEach(part => {
		const item = part.split("=");
		if (item[0]) {
			urlParameters[decodeURIComponent(item[0])] = item[1] && decodeURIComponent(item[1].split("+").join(" "));
		}
	});
	return urlParameters || {};
}



// WEBPACK FOOTER //
// ./src/opencell/pages/utils/UrlUtils.js